<div class="user-profile-wrapper ">
  <form novalidate [formGroup]="changePasswordForm" class="card" style="margin:auto;padding:50px"
    dynamicFlex="100|100|50|33|33">
    <div fxLayout="row wrap">
      <div fxLayout="row wrap" fxFlex="80" class="bold font-size-one-quarter">
        <label [textContent]="userName"></label>
      </div>
      <mat-form-field fxFlex="80">
        <input type="password" formControlName="oldPassword" matInput required
          placeholder="{{ 'passwordOld' | translate }}">
        <mat-error>{{getErrorMessage(changePasswordForm.get('oldPassword'))}}</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="80">
        <input type="password" formControlName="newPassword" matInput required
          placeholder="{{ 'newpassword'|translate}}">
        <mat-error>{{getErrorMessage(changePasswordForm.get('oldPassword'))}}</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="80">
        <input type="password" formControlName="confirmPassword" matInput required
          placeholder="{{ 'confirmnewpassword' | translate }}">
        <mat-error>{{getErrorMessage(changePasswordForm.get('oldPassword'))}}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="60px">
      <button mat-raised-button color="primary" type="button" [disabled]="changePasswordForm.invalid"
        (appHttpClick)="changePassword($event)">
        <i class="fas fa-paper-plane"></i>
        {{'submit'|translate}}
      </button>
    </div>
  </form>
</div>